import * as general from '../general';
export interface ClimateInnovationData {
  savedParkingPlacesNumber: number | null;
  savedParkingPlacesUndergroundNumber: number | null;
  savedArea: number | null;
  potentialUseChange:
  {
    label: string;
    value: number;
  }
  | null;
  potentialAdditionalArea: number | null;
  selectiveDeconstruction: boolean | null;
  massReusedConstructionProducts: number | null;
  climateInnovationPoints: number | null;
}

/**
 * @example {
 *  "acvDesignOffice": {
 *    "name": "string",
 *    "siret": "string",
 *    "address": "string",
 *    "postal": "string",
 *    "city": "string"
 *  },
 *  "earthQuakeZone": 0,
 *  "rsenvVersion": "string",
 *  "projectOwnerType": 2,
 *  "projectOwnerSiret": "123456789",
 *  "digitalModel": true,
 *  "formData": {},
 *  "buildings": [{
 *  "ZoneId": 123,
 *  "name": "MyZoneName",
 *  "type_structure_principale": 0,
 *  "elements_prefabriques": 0,
 *  "materiau_principal": 0,
 *  "materiau_remplissage_facade": 0,
 *  "mur_mode_isolation": 0,
 *  "mur_nature_isolant": 0,
 *  "mur_revetement_ext": 0,
 *  "type_fondation": 0,
 *  "type_plancher": 0,
 *  "plancher_mode_isolation": 0,
 *  "plancher_nature_isolant": 0,
 *  "plancher_nature_espace": 0,
 *  "type_toiture": 0,
 *  "toiture_mode_isolation": 0,
 *  "toiture_nature_isolant": 0,
 *  "toiture_vegetalisee": 0,
 *  "toiture_couverture": 0,
 *  "type_menuiserie": 0,
 *  "type_pm": 0,
 *  "vecteur_energie_principal_ch": 0,
 *  "vecteur_energie_principal_ecs": 0,
 *  "vecteur_energie_principal_fr": 0,
 *  "generateur_principal_ch": 0,
 *  "generateur_ch_liaison": 0,
 *  "emetteur_principal_ch": 0,
 *  "type_ventilation_principale": 0,
 *  "gestion_active": 0,
 *  "type_eclairage": 0,
 *  "speculativeDevelopment": true,
 *  "climateInnovationData": 
 *  {
 *    "savedParkingPlacesNumber": 2,
 *    "savedParkingPlacesUndergroundNumber": 3,
 *    "savedArea": 123,
 *    "potentialUseChange":
 *    {
 *      "label": "thing",
 *      "value": 1
 *    },
 *    "potentialAdditionalArea": 45,
 *    "selectiveDeconstruction": true,
 *    "massReusedConstructionProducts": 25
 *  } 
 * }]
 * }
 */
export interface ProjectDataComps {
  acvDesignOffice?: {
    name: string | null;
    siret: string | null;
    address: string | null;
    postal: string | null;
    city: string | null;
  } | null;
  earthQuakeZone: number | null;
  rsenvVersion: string | null;
  projectOwnerType: number | null;
  projectOwnerSiret: string | null;
  digitalModel: boolean | null;
  formData?: any;
  buildings: ProjectDataCompsBuilding[];
}

export interface ProjectDataCompsBuilding {
  ZoneId: number;
  name: string;
  type_structure_principale: number | null;
  elements_prefabriques: number | null;
  materiau_principal: number | null;
  materiau_remplissage_facade: number | null;
  mur_mode_isolation: number | null;
  mur_nature_isolant: number | null;
  mur_revetement_ext: number | null;
  type_fondation: number | null;
  type_plancher: number | null;
  plancher_mode_isolation: number | null;
  plancher_nature_isolant: number | null;
  plancher_nature_espace: number | null;
  type_toiture: number | null;
  toiture_mode_isolation: number | null;
  toiture_nature_isolant: number | null;
  toiture_vegetalisee: number | null;
  toiture_couverture: number | null;
  type_menuiserie: number | null;
  type_pm: number | null;
  vecteur_energie_principal_ch: number | null;
  vecteur_energie_principal_ecs: number | null;
  vecteur_energie_principal_fr: number | null;
  generateur_principal_ch: number | null;
  generateur_ch_liaison: number | null;
  emetteur_principal_ch: number | null;
  type_ventilation_principale: number | null;
  gestion_active: number | null;
  type_eclairage: number | null;
  climateInnovationData: ClimateInnovationData | null;
  speculativeDevelopment: boolean | null;
}

export interface ProjectDataCompsGetRequest {
  ProjectId: number;
}

export interface ProjectDataCompsGetResponse extends ProjectDataComps {}

export interface ProjectDataCompsPostRequest {
  ProjectId: number;
  Body: ProjectDataComps; 
}

export const successReturnMessage = "Data comps have been updated";
export const badRequestReturnMessage = "Missing parameters";
export const noDataErrorMessage = "No data comps found for this project";

export function getProjectDataCompsSuccess(projectDataComps: ProjectDataComps): general.SuccessReturnBody {
  return general.getSuccessReturnBody(projectDataComps);
}

export function getProjectDataCompsNoData(): general.MissingDataReturnBody {
  return general.getMissingDataReturnBody(noDataErrorMessage);
}

export function projectDataCompsBadRequest(): general.BadRequestReturnBody {
  return general.getBadRequestReturnBody(badRequestReturnMessage);
}

export function postProjectDataCompsSuccess(): general.SuccessReturnBody {
  return general.getSuccessReturnBody(successReturnMessage);
}

export function postProjectDataCompsServerError(): general.ServerErrorReturnBody {
  return general.getServerErrorReturnBody();
}